<script src="../store.js"></script>
<template>
  <div class="section">
    <div class="container">
      <div v-if="isSignedIn" class="container">
        <div v-if="resourceCalendars.length > 0">
          <h1 class="home__title">
            Raumauswahl
          </h1>

          <div class="home__resources">
            <div
              class="home__resources-item"
              v-for="resource in resourceCalendars"
              :key="resource.id"
              v-on:click="gotoResource(resource)"
            >
              <div class="home__box">
                <div class="home__box-color" :style="{backgroundColor: resource.backgroundColor}"></div>
                <p class="home__box-title" style="font-size:17px;">
                  {{ resource.summary | shortRoomName }}
                </p>
                <div class="home">
                  <div
                    :class="
                    $googleCalendarService.getRoomState(resourceEvents[resource.id], now).isOccupied
                      ? 'room-selector room-selector--occupied'
                      : 'room-selector room-selector--free'
                  "
                  >
                    {{
                      $googleCalendarService.getRoomState(resourceEvents[resource.id], now).isOccupied
                        ? "BELEGT"
                        : "FREI"
                    }}
                    <br/>
                    {{
                      $googleCalendarService.getRoomState(resourceEvents[resource.id], now)
                        .leftDuration | shortTimeFormatOcp
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="columns is-centered">
            <div class="column is-half">
              <div class="has-text-centered">
                <h1 class="home-noroom__title title">Leider kannst du keine Räume auswählen.</h1>
                <p class="home-noroom__instruction">Bitte wähle deine Räume aus. Sollten dort keine Räume vorhanden sein, melde dich bei <a href="mailto:service@enervolution.de">service@enervolution.de</a></p>
                <a href="https://calendar.google.com/calendar/u/0/r/settings/browseresources" target="_blank" class="button is-primary is-outlined">Räume auswählen</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-else>
        <div class="columns is-centered">
          <div class="column is-half">
            <div class="has-text-centered">
              <div class="card">
                <div class="card-content">
                  <p class="title">
                    Bitte mit Hilfe von Google einloggen um eine Ressource zu wählen.
                  </p>
                </div>
                <footer class="card-footer">
                  <p class="card-footer-item">
                    <span v-on:click="signIn">
                      Login
                    </span>
                  </p>
                </footer>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventDataMixin from './EventDataMixin.vue'

export default {
  name: 'home',
  mixins: [EventDataMixin],
  methods: {
    gotoResource (resource) {
      this.$router.push({ name: 'resource', params: { resourceId: resource.id } })
    },
    signIn () {
      this.$store.dispatch('signIn')
    }
  },
  computed: {
    isSignedIn () {
      return this.$store.state.isSignedIn
    }
  }
}
</script>

<style lang="scss">
@import "../assets/variables.scss";
.home {
  text-align: center;
  .room-selector {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    font-family: "Kumbh Sans", sans-serif;
    &--occupied {
      border: solid 3px $red;
      background: $red;
    }
    &--free {
      border: solid 3px $turquoise;
      background: $turquoise;
    }
  }

  &__title {
    color: $primary;
    margin-left: 5px;
    text-transform: uppercase;
    letter-spacing: 2px;
    font-family: "Kumbh Sans", sans-serif;
    font-weight: 400;
    margin-bottom: 10px;
  }

  &__resources {
    width: 90%;
    display: flex;
    flex-wrap: wrap;
  }
  &__box {
    background-color: $black-ter;
    border-radius: 5px;
    margin: 10px;
    box-shadow: -2px 2px 5px 0px rgba(0, 0, 0, 0.75);
    color: white;
    width: 200px;
    &-title {
      padding: 10px 5px;
      font-family: "Kumbh Sans", sans-serif;
      font-weight: 400;
      text-align: center;
    }

    &-color{
      width: 15px;
      height: 15px;
      border-top-right-radius: 5px;
      position: relative;
      left: 185px;
    }
  }
  &-noroom{
    &__title {
      color: white;
    }
    &__instruction{
      color: $white;
      margin-bottom: 30px;
      > a {
        color: $primary;
      }
    }
  }
}
</style>
